import React, { Component } from "react";

import { Link, Redirect, withRouter } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { toast } from "react-toastify";
import Url from "app/shared/constants/Url";
import axios from "axios";
import FetchWorkingDays from "app/views/Admin/WorkingDay/Services/fetchCompanyProfile";
import { UPDATE_PERMITTED_MODULE_LIST } from "app/redux/constant/ActionType";
import { connect } from "react-redux";
import { Eye, EyeOff } from "react-feather";
import { TIMEZONE_STR } from "app/shared/utility/helperStrings";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import AlertMessage from "app/shared/components/Popups/AlertMessage";
import { setupAutoLogout } from "./sessionManager";
const qs = require("qs");

const alertMsg = (props) => {
  toast.error(props.message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    showHidePassword: false,
    style: {
      backgroundColor: "red",
    },
    // ...(props.color && { style: { background: props.color } }),
  });
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateModuleList: (payloadData) => {
      dispatch({ type: UPDATE_PERMITTED_MODULE_LIST, payload: payloadData });
    },
  };
};

const POST_LOGIN_ROUTE_BY_HOST = {
  "nscindia.clideanalyser.in": "/survey",
};

const getPostLoginRoute = () => {
  const hostname = window.location.hostname;
  return POST_LOGIN_ROUTE_BY_HOST[hostname] || "/";
};

const getRedirectPath = (location) => {
  const referrerPath = location?.state?.from?.pathname || location?.state?.from;
  if (referrerPath && referrerPath !== "/auth/login") {
    return referrerPath;
  }
  return getPostLoginRoute();
};

class LoginForm extends Component {
  state = {
    type: 1,
    formSubmitting: false,
    redirectToReferrer: false,
    showOtpSection: false,
    showEmailForm: false,
    enteredOtp: "",
    prevPath: null,
    otp: ["", "", "", "", "", ""],
    isResendDisabled: true,
    timer: 15,
    loginDetail: {},
    isSSOEnable: false,
    subDomain: "",
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ prevPath: nextProps.location });
  }

  changeShowHidePassword = async () => {
    await this.setState({
      showHidePassword: !this.state.showHidePassword,
    });
  };

  verifyOtp = () => {
    const enteredOtp = this.state.otp.join("");

    if (enteredOtp.length !== 6) {
      alertMsg({ message: "Please enter the full 6-digit OTP!", color: "red" });
      return;
    }

    const requestBody = {
      otp: enteredOtp,
      user_id: this.state.userId,
      temp_authkey: this.state.tempAuthKey,
    };
    axios
      .post(Url.otpverification, qs.stringify(requestBody), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          const { kpi_flag, overview_flag } = data;
          let tempList = [...data.module];

          if (kpi_flag) {
            tempList = [
              ...tempList,
              {
                module_name: "kpi",
                status: kpi_flag,
              },
            ];
          }

          if (overview_flag) {
            tempList = [
              ...tempList,
              {
                module_name: "overview",
                status: overview_flag,
              },
            ];
          }

          this.props.updateModuleList(tempList.filter((item) => item.status));
          const userTZ =
            data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

          localStorage.setItem("userData", JSON.stringify(data));
          localStorage.setItem("userId", data.user_id);
          localStorage.setItem("token", data.auth_key);
          localStorage.setItem("springToken", data.auth_key);
          localStorage.setItem(TIMEZONE_STR, userTZ);
          moment.tz.setDefault(userTZ);
          this.setState({ redirectToReferrer: true });
          AlertMessage({
            message: "OTP verified successfully!",
            type: "success",
            color: this.props.themeColor,
          });
        } else {
          alertMsg({ message: res.data.msg, color: "red" });
          this.setState({ otp: ["", "", "", "", "", ""] });
        }
      })
      .catch(() => {
        alertMsg({
          message: "OTP verification failed. Please try again!",
          color: "red",
        });
      });
  };

  componentDidMount() {
    this._getLogo();
  }

  startResendTimer = () => {
    this.setState({ isResendDisabled: true, timer: 15 });
    const interval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.timer === 1) {
          clearInterval(interval);
          return { isResendDisabled: false, timer: 0 };
        }
        return { timer: prevState.timer - 1 };
      });
    }, 1000);
  };

  handleChange = (index, event) => {
    const value = event.target.value;
    if (!/^\d?$/.test(value)) return;

    let newOtp = [...this.state.otp];
    newOtp[index] = value;
    this.setState({ otp: newOtp });

    if (value && index < 5) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  handleKeyDown = (index, event) => {
    if (event.key === "Backspace") {
      let newOtp = [...this.state.otp];

      if (!newOtp[index] && index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }

      newOtp[index] = "";
      this.setState({ otp: newOtp });
    }
  };

  handleResend = () => {
    console.log("Resending OTP...");
    this.startResendTimer();
  };

  _getLogo = async () => {
    const requestData = {
      status: 1,
      link: Url.clientURL,
    };

    // Derive sub_domain from hostname — e.g. "qaclide.clideanalyser.in" → "qaclide"
    const hostname = window.location.hostname;
    const subDomain = hostname.replace(".clideanalyser.in", "").trim();

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.compnayLogo,
        undefined,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            const { login_type, isSSOEnable } = response.data.data;

            this.setState({
              type: login_type,
              isSSOEnable: !!isSSOEnable,
              subDomain,
            });
          }
        })
        .catch((error) => console.log("Error fetching loginType:", error));
    });
  };

  _handleSSOLogin = () => {
    window.location.href = `${Url.ssoLogin}?sub_domain=${this.state.subDomain}`;
  };

  resendOtp = async () => {
    this.startResendTimer();
    let requestData = {
      temp_authkey: this.state.tempAuthKey,
      user_id: this.state.userId,
    };

    let URL = Url.resendOtp;
    const contentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    console.log("Request Payload:", requestData);

    await axios
      .post(URL, qs.stringify(requestData), { headers: contentType })
      .then(async (response) => {
        if (response.data.status === 200) {
          AlertMessage({
            message: "OTP has been sent",
            type: "success",
            color: this.props.themeColor,
          });
        } else {
          this.setState({ formSubmitting: false });
        }
      })
      .catch(async (error) => {
        this.setState({ dataLoading: false });
      });
  };

  fetchWorkingDays = async () => {
    try {
      const data = await FetchWorkingDays();
      localStorage.setItem("workingDays", JSON.stringify(data?.data));
    } catch (error) {
      console.error("Failed to fetch clients", error);
    }
  };

  render() {
    if (localStorage.getItem("token") !== null || this.state.redirectToReferrer) {
      const targetPath = getRedirectPath(this.props.location);
      return <Redirect to={targetPath} />;
    }
    const { t } = this.props;
    const themeColor = this.props.themeColor;

    return (
      <div className="login-form">
        <div className="sign-header-section">
          <div className="sign-in-title" style={{ padding: "3% 0", margin: 0 }}>
            {t("login")}
          </div>
        </div>

        {!this.state.showOtpSection ? (
          this.state.type === 2 && !this.state.showEmailForm ? (
            <div style={{ marginTop: "8px" }}>
              <button
                type="button"
                onClick={() => this.setState({ showEmailForm: true })}
                className="w-100"
                style={{
                  padding: "12px 16px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor: themeColor,
                  color: "#fff",
                  fontWeight: 600,
                  width: "100%",
                  cursor: "pointer",
                }}
              >
                📧 Login with Email ID
              </button>

              {this.state.isSSOEnable && (
                <div style={{ marginTop: "16px", textAlign: "center" }}>
                  {/* Divider */}
                  <div
                    className="d-flex align-items-center gap-2 mb-3 text-muted"
                    style={{ fontSize: "13px" }}
                  >
                    <hr className="flex-grow-1 m-0" />
                    <span>or</span>
                    <hr className="flex-grow-1 m-0" />
                  </div>

                  {/* Centered Button */}
                  <button
                    type="button"
                    onClick={this._handleSSOLogin}
                    className="px-4 py-2"
                    style={{
                      border: `2px solid ${themeColor}`,
                      borderRadius: "10px",
                      backgroundColor: "#fff",
                      color: themeColor,
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = themeColor;
                      e.target.style.color = "#fff";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "#fff";
                      e.target.style.color = themeColor;
                    }}
                  >
                    🔐 Login with SSO
                  </button>
                </div>
              )}
            </div>
          ) : (
          <>
            {this.state.type === 2 && (
              <div style={{ marginBottom: "12px" }}>
                <span
                  onClick={() => this.setState({ showEmailForm: false })}
                  style={{
                    cursor: "pointer",
                    color: themeColor,
                    fontSize: "14px",
                    fontWeight: 500,
                    display: "inline-block",
                  }}
                >
                  ← Back
                </span>
              </div>
            )}
            <Formik
              initialValues={{ email: "", password: "", type: this.state.type }}
              enableReinitialize={true}
              validate={(values) => {
                let errors = {};
                if (!values.email) {
                  errors.email = t("emailIsRequired");
                } else if (
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                ) {
                  errors.email = t("invalidEmailAddressFormat");
                }
                if (
                  (values.type === 1 || values.type === 3) &&
                  !values.password
                ) {
                  errors.password = t("passwordRequired");
                }
                return errors;
              }}
              onSubmit={async (values, actions) => {
                this.setState({ formSubmitting: true });
                let requestBody = {
                  type: values.type,
                  email: values.email,
                };

                this.setState({
                  loginDetail: {
                    email: values.email,
                    password: values.password,
                  },
                });

                if (values.type === 1 || values.type === 3) {
                  requestBody.password = values.password;
                }
                axios
                  .post(
                    Url.login,
                    {
                      type: values.type,
                      email: values.email,
                      password: values.password,
                      otp_status: 1,
                    },
                    {
                      headers: {
                        "Content-Type": "application/json",
                      },
                    },
                  )
                  .then((res) => {
                    if (res.data.status == 200) {
                      const { data } = res.data;

                      localStorage.setItem("login_type", data.login_type);

                      if (values.type === 2 || values.type === 3) {
                        this.setState({
                          showOtpSection: true,
                          tempAuthKey: data.tempAuthKey,
                          userId: data.user_id,
                        });
                        this.startResendTimer();
                      } else {
                        const { kpi_flag, overview_flag } = data;
                        let tempList = [...data.module];

                        if (kpi_flag) {
                          tempList = [
                            ...tempList,
                            {
                              module_name: "kpi",
                              status: kpi_flag,
                            },
                          ];
                        }

                        if (overview_flag) {
                          tempList = [
                            ...tempList,
                            {
                              module_name: "overview",
                              status: overview_flag,
                            },
                          ];
                        }

                        this.props.updateModuleList(
                          tempList.filter((item) => item.status),
                        );
                        const userTZ =
                          data.time_zone ||
                          Intl.DateTimeFormat().resolvedOptions().timeZone;
                        localStorage.setItem("userData", JSON.stringify(data));
                        localStorage.setItem("userId", data.user_id);
                        localStorage.setItem("token", data.auth_key);
                        localStorage.setItem("springToken", data.auth_key);
                        localStorage.setItem(TIMEZONE_STR, userTZ);
                        this.fetchWorkingDays();
                        setupAutoLogout();
                        moment.tz.setDefault(userTZ);
                        this.setState({ redirectToReferrer: true });
                      }
                    } else {
                      alertMsg({ message: res.data.msg, color: "red" });
                    }
                    this.setState({ formSubmitting: false });
                  })
                  .catch((error) => {
                    this.setState({ formSubmitting: false });
                  });
              }}
            >
              {({
                touched,
                errors,
                isSubmitting,
                handleSubmit,
                isValid,
                dirty,
                values,
              }) => (
                <Form onSubmit={handleSubmit} className="input-container">
                  <div className="input-group">
                    <label className="font-weight-bold">Email</label>
                    <Field
                      name="email"
                      type="email"
                      placeholder={t("enterYourRegisteredEmailId")}
                      className="w-100 border-0"
                      style={{
                        padding: "12px 16px",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    />
                    <ErrorMessage
                      component="div"
                      name="email"
                      className="inputErrorMsg text-danger"
                    />
                  </div>
                  {this.state.type !== 2 && (
                    <div className="input-group">
                      <div
                        className="password-container w-100"
                        style={{ position: "relative" }}
                      >
                        <label className="font-weight-bold">Password</label>
                        <Field
                          type={
                            this.state.showHidePassword ? "text" : "password"
                          }
                          name="password"
                          placeholder={t("password")}
                          className="w-100 border-0"
                          style={{
                            padding: "12px 40px 12px 16px", // Right padding for eye icon
                            borderRadius: "8px",
                            border: "1px solid #ddd",
                            width: "100%",
                            boxSizing: "border-box",
                          }}
                        />

                        <span
                          className="toggle-password"
                          style={{
                            position: "absolute",
                            right: "12px",
                            top: "70%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                          }}
                        >
                          {this.state.showHidePassword ? (
                            <EyeOff
                              style={{
                                color: "grey",
                                height: "20",
                                width: "20",
                              }}
                              onClick={this.changeShowHidePassword}
                            />
                          ) : (
                            <Eye
                              style={{
                                color: "grey",
                                height: "20",
                                width: "20",
                              }}
                              onClick={this.changeShowHidePassword}
                            ></Eye>
                          )}
                        </span>
                      </div>
                      <ErrorMessage
                        component="div"
                        name="password"
                        className="inputErrorMsg text-danger"
                      />
                    </div>
                  )}
                  {this.state.type !== 2 && (
                    <div className="forget-div d-flex space-between">
                      <Link
                        className="color-primary text-decoration-none"
                        to={`/auth/reset-password`}
                      >
                        {t("resetPassword")}
                      </Link>
                      <Link
                        className="color-primary text-decoration-none"
                        to={`/auth/forget-password`}
                      >
                        {t("forgotPassword")}
                      </Link>
                    </div>
                  )}
                  <button
                    type="submit"
                    disabled={!isValid || this.state.formSubmitting}
                  >
                    {this.state.formSubmitting ? t("pleaseWait") : t("login")}
                  </button>
                </Form>
              )}
            </Formik>

            {this.state.type !== 2 && this.state.isSSOEnable && (
              <div style={{ marginTop: "16px", textAlign: "center" }}>
                {/* Divider */}
                <div
                  className="d-flex align-items-center gap-2 mb-3 text-muted"
                  style={{ fontSize: "13px" }}
                >
                  <hr className="flex-grow-1 m-0" />
                  <span>or</span>
                  <hr className="flex-grow-1 m-0" />
                </div>

                {/* Centered Button */}
                <button
                  type="button"
                  onClick={this._handleSSOLogin}
                  className="px-4 py-2"
                  style={{
                    border: `2px solid ${themeColor}`,
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                    color: themeColor,
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = themeColor;
                    e.target.style.color = "#fff";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#fff";
                    e.target.style.color = themeColor;
                  }}
                >
                  🔐 Login with SSO
                </button>
              </div>
            )}
          </>
          )
        ) : (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "10px",
              }}
            >
              Enter OTP
            </h3>

            {/* OTP Input Fields in a Single Row */}
            <div
              style={{ display: "flex", justifyContent: "center", gap: "8px" }}
            >
              {this.state.otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  value={digit}
                  onChange={(e) => this.handleChange(index, e)}
                  onKeyDown={(e) => this.handleKeyDown(index, e)}
                  maxLength={1}
                  style={{
                    width: "40px",
                    height: "40px",
                    fontSize: "20px",
                    textAlign: "center",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    outline: "none",
                    transition: "all 0.2s ease-in-out",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = themeColor)}
                  onBlur={(e) => (e.target.style.borderColor = "#ccc")}
                />
              ))}
            </div>

            {/* Verify OTP Button */}
            <button
              onClick={this.verifyOtp}
              disabled={this.state.otp.includes("")} // Button disabled if any field is empty
              style={{
                marginTop: "15px",
                padding: "10px 15px",
                fontSize: "16px",
                border: "none",
                borderRadius: "5px",
                cursor: this.state.otp.includes("") ? "not-allowed" : "pointer",
                backgroundColor: this.state.otp.includes("")
                  ? "#ccc"
                  : themeColor,
                color: "white",
              }}
            >
              Verify OTP
            </button>

            {/* Resend OTP Button with Timer */}
            <button
              onClick={this.resendOtp}
              disabled={this.state.isResendDisabled}
              style={{
                marginTop: "10px",
                marginLeft: "10px",
                padding: "10px 15px",
                fontSize: "16px",
                border: "none",
                borderRadius: "5px",
                cursor: this.state.isResendDisabled ? "not-allowed" : "pointer",
                backgroundColor: this.state.isResendDisabled
                  ? "#ccc"
                  : "#28a745",
                color: "white",
              }}
            >
              Resend OTP{" "}
              {this.state.isResendDisabled ? `(${this.state.timer}s)` : ""}
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default compose(
  withRouter,
  connect(null, mapDispatchToProps),
  withTranslation(["util"]),
)(LoginForm);
